class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.updateHeaderPosition = this.updateHeaderPosition.bind(this);
  }

  connectedCallback() {
    this.events?.abort();
    this.events = new AbortController();
    const options = { signal: this.events.signal, passive: true };
    window.addEventListener('resize', this.updateHeaderPosition, options);
    // Do not leave a detached menu behind after its navigation row leaves the screen.
    window.addEventListener('scroll', () => {
      if (!this.mainDetailsToggle.open) return;
      if (this.mainDetailsToggle.querySelector('summary').getBoundingClientRect().bottom <= 0) this.close();
      else this.updateHeaderPosition();
    }, options);
    document.addEventListener('pointerdown', event => {
      if (this.mainDetailsToggle.open && !this.contains(event.target)) this.close();
    }, options);
  }

  disconnectedCallback() {
    this.events?.abort();
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    if (this.mainDetailsToggle.open) {
      this.header.querySelectorAll('header-menu').forEach(menu => {
        if (menu !== this) menu.close();
      });
      this.content.scrollTop = 0;
    }
    this.header.preventHide = !!this.header.querySelector('header-menu details[open]');
    this.updateHeaderPosition();
  }

  close() {
    super.close();
    if (this.header) this.header.preventHide = !!this.header.querySelector('header-menu details[open]');
  }

  updateHeaderPosition() {
    if (!this.header || !this.mainDetailsToggle.open) return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
